<script>
	import { afterUpdate, onDestroy } from 'svelte';
	import { base } from '$app/paths';
	import SeoHead from '../../common/SeoHead.svelte';
	import { enhanceNonSync } from './enhance.js';
	import './sourceStyles.css';

	export let document;
	let content;
	let initialized;
	let cleanup;
	afterUpdate(() => {
		if (!content || initialized === document) return;
		cleanup?.();
		cleanup = enhanceNonSync(content.querySelector('.nsp-site'));
		initialized = document;
	});
	onDestroy(() => cleanup?.());
	$: manual = document.section === 'manual';
	$: canonical = `https://tools.d-cine.net${base}${document.path}`;
	$: schema = JSON.stringify({
		'@context': 'https://schema.org',
		'@graph': [
			{
				'@type': manual ? 'TechArticle' : 'WebPage',
				name: document.title,
				headline: document.title,
				description: document.description,
				url: canonical,
				dateModified: document.updated,
				inLanguage: 'en',
				image: `https://tools.d-cine.net${base}${document.image}`,
				author: { '@type': 'Person', name: 'James Gardiner' }
			},
			{
				'@type': 'BreadcrumbList',
				itemListElement: [
					{
						name: 'Non-Sync Player',
						item: `https://tools.d-cine.net${base}/non-sync-player/about/`
					},
					...(document.slug === 'about' ? [] : [{ name: document.label, item: canonical }])
				].map((item, index) => ({ '@type': 'ListItem', position: index + 1, ...item }))
			},
			...(document.slug === 'about'
				? [
						{
							'@type': 'SoftwareApplication',
							name: 'Non-Sync Player',
							applicationCategory: 'MultimediaApplication',
							operatingSystem: 'Android TV',
							softwareVersion: document.version,
							url: canonical,
							downloadUrl: 'https://www.d-cine.net/non-sync-player-apk/',
							image: `https://tools.d-cine.net${base}${document.image}`,
							description: document.description
						}
					]
				: [])
		]
	}).replace(/</g, '\\u003c');
</script>

<SeoHead
	title={document.title}
	description={document.description}
	path={document.path}
	image={document.image}
	type={manual ? 'article' : 'website'}
/>
<svelte:head>{@html `<script type="application/ld+json">${schema}</script>`}</svelte:head>

<div class="doc-content" bind:this={content}>
	{@html document.html.replaceAll('__APP_BASE__', base)}
</div>
